import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20639796"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alarmMonitor"
};
import { reactive, ref, toRefs, computed, watch, nextTick } from "vue";
import { useRoute, useRouter } from 'vue-router';
// import alarmAnalysis  from './components/alarmAnalysis/index.vue'
import alarmRealTime from './components/alarmRealTime.vue';
import alarmHistory from "./components/alarmHistory.vue";
export default {
  __name: 'index',
  setup(__props) {
    const state = reactive({
      activeName: "alarmRealTime"
    });
    const route = useRoute();
    const router = useRouter();
    if (route.query.deviceId && route.query.isActive == 'alarmRealTime') {
      state.activeName = 'alarmRealTime';
    }
    const handleNodeClick = function (val) {
      if (!val.children || val.children.length === 0) {
        // nodeType 为5 是叶子节点才会发起请求 下发id
        if (val.nodeType === 5) {
          state.routePath = val.routePath;
          state.deviceId = val.powerSystemResourceId;
          state.currentDevice = val;
          state.curComponent = val.routePath;
          state.hasJianCe = state.typeArray.includes(val.psrType);
        }
      }
    };
    //跳转参数
    let routeParams = ref({
      feelName: '',
      //线路名称
      beginTime: '',
      endTime: '',
      dateRange: [],
      alarmType: ''
    });
    const routeHandle = val => {
      Object.assign(routeParams.value, val);
      state.activeName = 'alarmHistory';
    };
    const tabClick = val => {
      // 暂时注释
      // router.push({
      //   query: {
      //     id:'',
      //   },
      // });
      routeParams.value = {
        feelName: '',
        beginTime: '',
        endTime: '',
        dateRange: [],
        alarmType: '',
        alarmStatus: ''
      };
    };
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: state.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.activeName = $event),
        class: "alarmMonitor-tabs",
        onTabClick: tabClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "实时告警",
          name: "alarmRealTime"
        }, {
          default: _withCtx(() => [state.activeName === 'alarmRealTime' ? (_openBlock(), _createBlock(alarmRealTime, {
            key: 0,
            deviceCode: _unref(route).query.deviceCode
          }, null, 8, ["deviceCode"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "历史记录",
          name: "alarmHistory"
        }, {
          default: _withCtx(() => [state.activeName === 'alarmHistory' ? (_openBlock(), _createBlock(alarmHistory, {
            key: 0,
            routeParams: _unref(routeParams)
          }, null, 8, ["routeParams"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};